import styled from "@emotion/styled";

export const StackItemElement = styled.div<{ gap: number }>(props => ({
    marginTop: props.gap,

    ":first-of-type": {
        marginTop: 0,
    },

    ":empty": {
        marginTop: 0,
    },

    ":first-of-type:empty + &": {
        marginTop: 0,
    },

    ":first-of-type:empty + :empty + &": {
        marginTop: 0,
    },

    ":first-of-type:empty + :empty + :empty + &": {
        marginTop: 0,
    },

    ":first-of-type:empty + :empty + :empty + :empty + &": {
        marginTop: 0,
    },

    ":first-of-type:empty + :empty + :empty + :empty + :empty + &": {
        marginTop: 0,
    },
}));

export const StackElement = styled.div({
    display: "flex",
    flexDirection: "column",
    justifyContent: "stretch",
});
